import { render } from "./editRecord.vue?vue&type=template&id=2ce730ef&scoped=true"
import script from "./editRecord.vue?vue&type=script&lang=js"
export * from "./editRecord.vue?vue&type=script&lang=js"

import "./editRecord.vue?vue&type=style&index=0&id=2ce730ef&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce730ef"]])

export default __exports__